import { render, staticRenderFns } from "./WidgetBuilderNew.vue?vue&type=template&id=382aae16&scoped=true&"
import script from "./WidgetBuilderNew.vue?vue&type=script&lang=js&"
export * from "./WidgetBuilderNew.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBuilderNew.vue?vue&type=style&index=0&id=382aae16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382aae16",
  null
  
)

export default component.exports